(() => {
  if (window.__bnonAnalytics || window.Shopify?.designMode) return;
  window.__bnonAnalytics = true;

  const serviceHandles = ['shopify-store-development', 'digital-marketing', 'us-corporation-3pl', 'amazon', 'shopify-education'];
  const serviceValues = new Map([
    ['스토어 구축', 'store_development'],
    ['쇼피파이 관리자 교육', 'shopify_education'],
    ['제품 이미지 및 상세페이지 제작', 'creative'],
    ['마케팅 (메타, 구글, SEO)', 'digital_marketing'],
    ['아마존 입점', 'amazon'],
    ['미국 법인 설립 & 은행계좌 개설', 'us_corporation'],
    ['글로벌 3PL 물류', 'global_3pl'],
    ['미국 틱톡샵 계정 생성', 'tiktok_shop']
  ]);
  const formSelector = 'bnon-contact-page form.bnon-contact-form';
  const trackedForms = new WeakMap();
  const viewedSections = new Set();
  const timers = new Map();
  let activated = false;
  let sectionObserver;
  const current = new URL(window.location.href);
  const serviceFromURL = (url) => {
    if (url.origin !== current.origin) return '';
    const handle = url.pathname.replace(/\/$/, '').split('/').pop();
    if (serviceHandles.includes(handle)) return handle;
    const view = url.searchParams.get('view');
    return handle === 'service' && serviceHandles.includes(view) ? view : '';
  };
  const serviceType = serviceFromURL(current);
  const pageHandle = current.pathname.replace(/\/$/, '').split('/').pop();
  const pageType = serviceType ? 'service_detail' : current.pathname === '/' ? 'home' :
    ['contact', 'about', 'portfolio', 'service'].includes(pageHandle) ? pageHandle : 'other';
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const storage = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } },
    remove(key) { try { sessionStorage.removeItem(key); } catch {} }
  };
  const fields = ['page_type', 'service_type', 'cta_location', 'contact_method', 'form_id', 'form_step', 'error_type', 'project_name', 'section_name', 'document_name'];
  const emit = (name, params = {}) => {
    if (!allowed()) return false;
    const record = { event: 'bnon_analytics', bn_event_name: name, bn_tracking_version: '1.1' };
    fields.forEach((key) => { record[`bn_${key}`] = ''; });
    record.bn_page_type = pageType;
    record.bn_service_type = serviceType;
    fields.forEach((key) => {
      if (params[key] !== undefined) record[`bn_${key}`] = String(params[key]).slice(0, 100);
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(record);
    return true;
  };
  const placement = (element) => {
    if (element.closest('.bnon-header__mobile-menu')) return 'header_mobile';
    if (element.closest('.bnon-header')) return 'header';
    if (element.closest('#kakao-widget-fixed')) return 'floating';
    if (element.closest('.bnon-footer-v2, .bnon-footer')) return 'footer';
    if (element.closest('.bnon-contact-page')) return 'contact_page';
    if (element.closest('.bnon-about')) return 'about_page';
    if (element.closest('.bnon-main-portfolio')) return 'home_portfolio';
    if (element.closest('.bnon-contact')) return 'contact_cta';
    return 'page_content';
  };
  const selectedServices = (form) => [...form.querySelectorAll('[data-service-option]:checked')]
    .map((field) => serviceValues.get(field.value)).filter(Boolean).join('|');
  const progress = (form) => {
    const name = form.querySelector('[autocomplete="name"]');
    const email = form.querySelector('[type="email"]');
    const basic = Boolean(name?.value.trim() && email?.value.trim() && email.checkValidity());
    const services = Boolean(selectedServices(form));
    const privacy = Boolean(form.querySelector('[data-privacy]')?.checked);
    return { basic, services, privacy, valid: basic && services && privacy };
  };
  const pendingKey = (form) => `bnon:pending:${form.id}`;
  const onFormInput = (event) => {
    if (!allowed()) return;
    const form = event.target.closest(formSelector);
    if (!form) return;
    let state = trackedForms.get(form);
    if (!state) {
      state = new Set();
      trackedForms.set(form, state);
      emit('contact_form_start', { form_id: 'bnon_contact', contact_method: 'form' });
    }
    const status = progress(form);
    ['basic', 'services', 'privacy'].forEach((step) => {
      if (status[step] && !state.has(step)) {
        state.add(step);
        emit('contact_form_progress', { form_id: 'bnon_contact', form_step: step, service_type: selectedServices(form) });
      }
    });
    if (event.type === 'change' && event.target.matches('[data-service-option]:checked')) {
      const service = serviceValues.get(event.target.value);
      if (service) emit('inquiry_service_selected', { service_type: service, form_id: 'bnon_contact' });
    }
  };
  const checkResults = () => {
    if (!allowed()) return;
    document.querySelectorAll(formSelector).forEach((form) => {
      const key = pendingKey(form);
      const pending = storage.get(key);
      if (!pending || typeof pending.time !== 'number' || Date.now() - pending.time > 1800000 || pending.time > Date.now()) {
        storage.remove(key);
        return;
      }
      if (form.querySelector('[data-bnon-contact-success]')) {
        storage.remove(key);
        emit('generate_lead', { form_id: 'bnon_contact', contact_method: 'form', service_type: pending.services || '' });
      } else if (form.querySelector('[data-bnon-contact-error]')) {
        storage.remove(key);
        emit('contact_form_error', { form_id: 'bnon_contact', error_type: 'server_rejected' });
      }
    });
  };
  document.addEventListener('input', onFormInput);
  document.addEventListener('change', onFormInput);
  document.addEventListener('submit', (event) => {
    if (!allowed() || !event.target.matches(formSelector)) return;
    const form = event.target;
    // CAPTCHA can prevent the native submit while it verifies the visitor.
    // Keep a valid attempt until the server confirms success or rejection.
    if (!progress(form).valid) {
      storage.remove(pendingKey(form));
      emit('contact_form_error', { form_id: 'bnon_contact', error_type: 'client_validation' });
      return;
    }
    storage.set(pendingKey(form), { time: Date.now(), services: selectedServices(form) });
    emit('contact_submit_attempt', { form_id: 'bnon_contact', contact_method: 'form', service_type: selectedServices(form) });
  });
  document.addEventListener('click', (event) => {
    if (!allowed() || !(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (link) {
      let url;
      try { url = new URL(link.href, current); } catch { return; }
      const params = { cta_location: placement(link) };
      if (url.hostname === 'pf.kakao.com') emit('kakao_click', { ...params, contact_method: 'kakao' });
      else if (link.matches('[data-company-deck-download]')) emit('company_profile_download', { ...params, document_name: 'company_profile' });
      else if (url.protocol === 'tel:') emit('contact_phone_click', { ...params, contact_method: 'phone' });
      else if (url.protocol === 'mailto:') emit('contact_email_click', { ...params, contact_method: 'email' });
      else if (url.origin === current.origin && (/\/pages\/contact\/?$/.test(url.pathname) || url.hash === '#contact-form')) emit('contact_cta_click', params);
      else if (serviceFromURL(url)) emit('service_detail_click', { ...params, service_type: serviceFromURL(url) });
      if (link.matches('.bnon-mockup-modal__live-site')) {
        const trigger = link.closest('bnon-mockup-modal')?.trigger;
        emit('portfolio_live_site_click', { ...params, project_name: (trigger?.dataset.mockupTitle || 'unknown').slice(0, 80) });
      }
    }
    const faq = event.target.closest('[data-bnon-faq-trigger], bnon-shopify-faq summary');
    if (faq) setTimeout(() => {
      if (faq.getAttribute('aria-expanded') === 'true') emit('faq_open', { section_name: faq.id.replace(/[^a-zA-Z0-9_-]/g, '').slice(-80) });
    }, 0);
  });
  document.addEventListener('bnon:portfolio-open', (event) => {
    const trigger = event.detail?.trigger;
    if (!(trigger instanceof Element)) return;
    emit('portfolio_open', { project_name: (trigger.dataset.mockupTitle || 'unknown').slice(0, 80), cta_location: placement(trigger) });
  });
  const sectionNames = new Map([
    ['bnon-main-portfolio', 'home_portfolio'],
    ['bnon-what-we-do', 'home_services'],
    ['bnon-contact', 'contact_cta'],
    ['bnon-faq', 'faq'],
    ['bnon-service-page', 'service_overview'],
    ['bnon-portfolio-projects', 'portfolio_projects'],
    ['bnon-contact-page', 'contact_form']
  ]);
  const sectionName = (element) => [...sectionNames].find(([className]) => element.classList.contains(className))?.[1];
  const visible = (element) => {
    const rect = element.getBoundingClientRect();
    const overlap = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    return !document.hidden && rect.width > 0 && overlap >= Math.min(250, rect.height * 0.25);
  };
  const observeSections = () => {
    if (!sectionObserver || !allowed()) return;
    document.querySelectorAll([...sectionNames.keys()].map((name) => `.${name}`).join(',')).forEach((element) => {
      if (!viewedSections.has(sectionName(element))) sectionObserver.observe(element);
    });
  };
  const activate = () => {
    if (!allowed()) {
      timers.forEach(clearTimeout);
      timers.clear();
      sectionObserver?.disconnect();
      document.querySelectorAll(formSelector).forEach((form) => storage.remove(pendingKey(form)));
      return;
    }
    if (!activated) {
      activated = true;
      if (serviceType) emit('service_detail_view');
      if ('IntersectionObserver' in window) {
        sectionObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            const name = sectionName(target);
            if (!isIntersecting || !visible(target)) {
              clearTimeout(timers.get(target));
              timers.delete(target);
              return;
            }
            if (viewedSections.has(name) || timers.has(target)) return;
            timers.set(target, setTimeout(() => {
              timers.delete(target);
              if (visible(target) && emit('section_view', { section_name: name })) {
                viewedSections.add(name);
                sectionObserver.unobserve(target);
              }
            }, 1000));
          });
        }, { threshold: [0, 0.01, 0.05, 0.1, 0.25, 0.5, 1] });
      }
    }
    checkResults();
    observeSections();
  };
  document.addEventListener('visitorConsentCollected', activate);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      timers.forEach(clearTimeout);
      timers.clear();
      sectionObserver?.disconnect();
    } else observeSections();
  });
  if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) activate();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) activate();
    });
  }
})();
